/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PatternQualifier = {
    CaseInsensitive: 'case_insensitive'
} as const;
export type PatternQualifier = typeof PatternQualifier[keyof typeof PatternQualifier];


export function PatternQualifierFromJSON(json: any): PatternQualifier {
    return PatternQualifierFromJSONTyped(json, false);
}

export function PatternQualifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatternQualifier {
    return json as PatternQualifier;
}

export function PatternQualifierToJSON(value?: PatternQualifier | null): any {
    return value as any;
}

